// extracted by mini-css-extract-plugin
export default {"val":"styles_val__lcQnF"};